import styled from 'styled-components'

export const Subtitle = styled.h4`
  font-weight: 700;
  font-size: 18px;
  color: #1f2124;
  text-align: left;
  margin: 0;
  padding: 0;
`
